export function stopPropagation(event) {
    event.stopPropagation();
}
export function scrollIntoView(element) {
    element === null || element === void 0 ? void 0 : element.scrollIntoView({ inline: 'nearest', block: 'nearest' });
}
